// language=GraphQL
export const ALL_RATIO_CONFIGS_QUERY = `query Query($withTravelDocumentationServices: Boolean = false, $withBargainConfig: Boolean = false, $withBargainConfigTiers: Boolean = false, $withEsimConfig: Boolean = false, $withEsimConfigRegions: Boolean = false) {
  ratioConfigs: ratioConfigs {
    id
    travelDocumentationServices @include(if: $withTravelDocumentationServices) {
      id
      printServiceNo
      electronicServiceNo
    }
    bargainConfig @include(if: $withBargainConfig) {
      id
      active
      tiers @include(if: $withBargainConfigTiers) {
        id
        fromPrice
        discount
      }
      priceCap
      serviceCodePrefix
    }
    esimConfig @include(if: $withEsimConfig) {
      id
      enabled
      regions @include(if: $withEsimConfigRegions) {
        id
        name
        serviceCodePrefix
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_RATIO_CONFIG_QUERY = `query Query($id: ID!, $withTravelDocumentationServices: Boolean = false, $withBargainConfig: Boolean = false, $withBargainConfigTiers: Boolean = false, $withEsimConfig: Boolean = false, $withEsimConfigRegions: Boolean = false) {
  ratioConfig: ratioConfig(id: $id) {
    id
    travelDocumentationServices @include(if: $withTravelDocumentationServices) {
      id
      printServiceNo
      electronicServiceNo
    }
    bargainConfig @include(if: $withBargainConfig) {
      id
      active
      tiers @include(if: $withBargainConfigTiers) {
        id
        fromPrice
        discount
      }
      priceCap
      serviceCodePrefix
    }
    esimConfig @include(if: $withEsimConfig) {
      id
      enabled
      regions @include(if: $withEsimConfigRegions) {
        id
        name
        serviceCodePrefix
      }
    }
  }
}`

// language=GraphQL
export const CREATE_RATIO_CONFIG_MUTATION = `
  mutation Mutation($input: CreateRatioConfigInput, $withTravelDocumentationServices: Boolean = false, $withBargainConfig: Boolean = false, $withBargainConfigTiers: Boolean = false, $withEsimConfig: Boolean = false, $withEsimConfigRegions: Boolean = false) {
    ratioConfig: createRatioConfig(input: $input) {
      id
      travelDocumentationServices @include(if: $withTravelDocumentationServices) {
        id
        printServiceNo
        electronicServiceNo
      }
      bargainConfig @include(if: $withBargainConfig) {
        id
        active
        tiers @include(if: $withBargainConfigTiers) {
          id
          fromPrice
          discount
        }
        priceCap
        serviceCodePrefix
      }
      esimConfig @include(if: $withEsimConfig) {
        id
        enabled
        regions @include(if: $withEsimConfigRegions) {
          id
          name
          serviceCodePrefix
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_RATIO_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateRatioConfigInput, $withTravelDocumentationServices: Boolean = false, $withBargainConfig: Boolean = false, $withBargainConfigTiers: Boolean = false, $withEsimConfig: Boolean = false, $withEsimConfigRegions: Boolean = false) {
    ratioConfig: updateRatioConfig(input: $input) {
      id
      travelDocumentationServices @include(if: $withTravelDocumentationServices) {
        id
        printServiceNo
        electronicServiceNo
      }
      bargainConfig @include(if: $withBargainConfig) {
        id
        active
        tiers @include(if: $withBargainConfigTiers) {
          id
          fromPrice
          discount
        }
        priceCap
        serviceCodePrefix
      }
      esimConfig @include(if: $withEsimConfig) {
        id
        enabled
        regions @include(if: $withEsimConfigRegions) {
          id
          name
          serviceCodePrefix
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_RATIO_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteRatioConfigInput) {
    deleteRatioConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_RATIO_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteRatioConfigInput) {
    forceDeleteRatioConfig(input: $input) {
      success
    }
  }`
